const coordinatesTo2D = coordinates => {
  if (!Array.isArray(coordinates)) return coordinates;
  if (
    coordinates.length >= 2 &&
    typeof coordinates[0] === 'number' &&
    typeof coordinates[1] === 'number'
  ) {
    return coordinates.slice(0, 2);
  }
  return coordinates.map(coordinatesTo2D);
};

/**
 * Normaliza la geometría que se envía al microservicio sin modificar la
 * feature que el usuario ve en el mapa.
 *
 * Algunos KMZ/KML representan un polígono único como MultiPolygon y conservan
 * una coordenada Z. Los proveedores del geoproceso esperan anillos XY de un
 * Polygon en ese caso. Un MultiPolygon realmente compuesto por varias partes
 * se conserva como tal para no alterar su significado espacial.
 */
export const normalizeGeoprocessingGeometry = geometry => {
  if (!geometry || !geometry.type || !Array.isArray(geometry.coordinates)) {
    return geometry;
  }

  const coordinates = coordinatesTo2D(geometry.coordinates);
  if (geometry.type === 'MultiPolygon' && coordinates.length === 1) {
    return {
      ...geometry,
      type: 'Polygon',
      coordinates: coordinates[0],
    };
  }

  return { ...geometry, coordinates };
};

